import { useEffect, useState } from 'react';
import { Button } from '../components';
import { IconShare } from './icons';
import './shell.css';

const KEY = '205.install.dismissed';

function isIosSafari(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const iOS = /iPad|iPhone|iPod/.test(ua)
    // iPadOS 13+ reports as a Mac; a touch-capable "Mac" is an iPad.
    || (/Macintosh/.test(ua) && typeof document !== 'undefined' && navigator.maxTouchPoints > 1);
  const safari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  return iOS && safari;
}

function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const legacy = (navigator as Navigator & { standalone?: boolean }).standalone;
  return window.matchMedia?.('(display-mode: standalone)').matches || legacy === true;
}

/**
 * iOS never fires `beforeinstallprompt`, so there is no install button to
 * show — the only way onto the home screen is Share → Add to Home Screen.
 * This is that instruction, shown only where it is true, and dismissible for
 * good.
 */
export function InstallCoach() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isIosSafari() || isStandalone()) return;
    try { if (localStorage.getItem(KEY)) return; } catch { /* blocked storage: show it once */ }
    // Let the first screen land before asking for anything.
    const t = setTimeout(() => setShow(true), 2600);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    try { localStorage.setItem(KEY, '1'); } catch { /* fine */ }
    setShow(false);
  };

  return (
    <aside className="sh-coach no-print" role="note">
      <div style={{ color: 'var(--accent)', marginTop: 2 }}><IconShare size={20} /></div>
      <div style={{ minWidth: 0 }}>
        <div className="sh-coach__title">Put 205 on your home screen</div>
        <div className="sh-coach__body">
          Tap <span className="sh-coach__key">Share</span> in Safari, then
          {' '}<strong>Add to Home Screen</strong>. It opens full screen, with the
          tab bar where your thumb already is.
        </div>
        <div className="row" style={{ marginTop: 10 }}>
          <Button size="sm" variant="ghost" onClick={dismiss}>Not now</Button>
          <Button size="sm" onClick={dismiss}>Got it</Button>
        </div>
      </div>
    </aside>
  );
}
